import { addShells } from '../../../../../shared/redis';
import { Suggestion, SuggestionType } from '../types';

export const EVENTS_NAME_MAP: Record<SuggestionType, string> = {
  openTab: 'Open tab',
  organic: 'Search autosuggestion',
  organicProvided: 'Submitted term',
  ad: 'Ad',
  url: 'URL returned by search autosuggestion',
  urlCandidate: 'Submitted URL',
  tile: 'Top site or shortcut',
  website: 'Popular website',
  history: 'Website from history',
  historyOrganic: 'Search history',
  instantResult: 'Instant search result',
  instantResultAd: 'Instant ad search result',
  searchTag: 'Search tag',
  placeholder: 'Placeholder',
};

export const trackSubmit = async (
  suggestion: Suggestion,
  gain: number,
  gainType: string,
): Promise<void> => {
  // Search_from_ntp
  addShells(gainType === 'various' ? gain : 0);

  if (suggestion && suggestion.type === 'ad') {
    // Clicked_on_a_cps_ad_in_ntp_search_box
    addShells(gain);
  }
};